import { useActivityPermissions } from "PFApp/activities/hooks";
import { isProfileActive } from "PFCore/helpers/profile";
import { Activity, Shortlist } from "PFTypes";

import FillAuditRoleButton from "../../../../activities/show/parts/fill_audit_role_button";

type PendingButtonsProps = {
  isAudit: boolean;
  activity: Activity;
  qaPrefix?: string;
  parentActivity: Activity | null;
  item: Shortlist;
};

const FillRoleButton = ({ item, activity, parentActivity }: PendingButtonsProps) => {
  const { canReviewShortlists } = useActivityPermissions(activity);

  if (!canReviewShortlists || !isProfileActive(item.profile) || !parentActivity) {
    return null;
  }

  return <FillAuditRoleButton shortlistItem={item} engagement={parentActivity} activity={activity} />;
};

export default FillRoleButton;
